import { ourProcess } from "./ourProcess.css";

interface ourProcessCssProps {
  backgroundColor?: string;
  titleColor?: string;
}

export const ourProcessCss = (props: ourProcessCssProps) => (`

  ${ourProcess}

  section {
    background-color: ${props.backgroundColor ?? "#FCEDBD"}
  }

  .section-title {
    color: ${props.titleColor ?? "black"}
  }

`)